<template>
  <div class="finance">
    <new-transaction-modal ref="typeModal" @submitted="modalIsSubmitted" />
    <edit-transaction-modal ref="editTransactionModal" @submitted="modalIsSubmitted" />
    
    <m-finance-transaction

      ref="depositModal"
      :active="isShowFinanceTransactionModal"
      :type="switcherLocal"
      :current-user-personal-amount="personalAccountAmountLocal"
      @close="isShowFinanceTransactionModal = false"
      @submitPersonalAccount="addDataToPersonalAccount"
      @submitDeposit="addDataToDeposit"
      @submitAccountableTransaction="addDataToAccountableTransaction"
    />
    <m-remove-transaction ref="removeTransaction" @remove="removeTransactionSubmit" />
    
    <div class="finance__header">
      <c-switcher
        v-if="userHavePermissionDeposit() || userHavePermissionPersonalAccount() || userHavePermissionAccountable()"
        v-model="switcherLocal"
        class="finance__switcher h-switcher"
        type="group"
        :items="switcherLocalItems"
      />

      <!-- <h4 v-if="userHavePermissionPersonalAccount() && !userHavePermissionDeposit()">Личный счёт</h4>
      <h4 v-if="!userHavePermissionPersonalAccount() && userHavePermissionDeposit()">Депозит</h4> -->

      <div class="finance-change">
        <div
          v-if="switcherLocal === 'personal_account'"
          class="finance-change-personal-account-amount"
          :class="{
            'finance-change-personal-account-amount-red': personalAccountAmountLocal < 0,
            'finance-change-personal-account-amount-black': personalAccountAmountLocal === 0,
            'finance-change-personal-account-amount-green': personalAccountAmountLocal > 0,
          }"
        >
          {{ formatAmount(personalAccountAmountLocal) }}
          {{currencyLabel}}
        </div>
        <div v-if="switcherLocal === 'deposit'" class="finance-change-deposit">
          <div
            class="finance-change-deposit-amount"
            :class="{
              'finance-change-deposit-amount-yellow':
                depositAmountLocal > 0 && depositAmountLocal < depositAmountMaxLocal,
              'finance-change-deposit-amount-red': depositAmountLocal > depositAmountMaxLocal || depositAmountLocal <= 0,
              'finance-change-deposit-amount-green': depositAmountLocal === depositAmountMaxLocal,
            }"
          >
            {{ formatAmount(depositAmountLocal) }}
            {{currencyLabel}}
          </div>
          <div class="finance-change-deposit-description">
            <div class="finance-change-deposit-description-count">
              из <b>{{ depositAmountMaxLocal }}</b> <span>{{currencyLabel}}</span>
            </div>
            <div class="finance-change-deposit-description-desc">
              {{ getDepositAmountStatus() }}
            </div>
          </div>
        </div>
        <div
          v-if="switcherLocal === 'accountable-transaction'"
          class="finance-change-personal-account-amount"
          :class="{
            'finance-change-personal-account-amount-red': accountableTransactionAmountLocal < 0,
            'finance-change-personal-account-amount-gray': accountableTransactionAmountLocal === 0,
            'finance-change-personal-account-amount-green': accountableTransactionAmountLocal > 0,
          }"
        >
          {{ formatAmount(accountableTransactionAmountLocal) }}
          {{currencyLabel}}
        </div>
        
        <c-button
          v-if="displayFinanceChangeButton"
          class="finance-change-button"
          label="Внести/снять средства"
          @click="showTransactionModal()"
        />
      </div>
    </div>
    
    <div class="finance-change-history">
      <div class="finance-change-history-title">История изменений</div>
      <div class="finance-change-filters" :class="{ 'finance-change-filters--hide': !areFiltersExpanded || !areFiltersExpandedMobile, 'finance-change-filters--deposit': switcherLocal === 'deposit', }">
        <div class="finance-change-filters-row row">
          <c-button
            v-if="switcherLocal === 'personal_account'"
            class="finance-change-filters__switcher finance-change-filters__switcher--mobile"
            :label="areFiltersExpandedMobile ? 'Свернуть фильтры' : 'Показать фильтры'"
            size="small"
            @click="expandHideFiltersMobile"
          />
          <div v-if="areFiltersExpandedMobile" class="col col-12 col-md-4 col-xl-3 col--transaction-date-period">
            <c-input
              class="finance-change-history-filters-period"
              ref="financePeriod"
              v-model="periodLocal"
              label="Период учётной даты"
              placeholder="00.00.0000 - 00.00.0000"
              type="period"
              icon="calendar"
              :clearable="periodLocal"
              :icon-right="true"
            />
          </div>
          <div v-if="switcherLocal === 'personal_account' && areFiltersExpandedMobile" class="col col-12 col-md-8 col-xl-5 col--transaction-type">
            <c-select-2
              v-model="filtersForm.selectedTransactionTypes"
              type="select"
              label="Тип проводки"
              :multiple="true"
              :searchable="true"
              :placeholder="'Любой'"
              :items="transactionTypes.items"
              :groups="transactionTypes.groups"
              :checkbox="true"
              :checkbox-value="transactionTypes.reverse"
              :checkbox-type="'icon'"
              :checkbox-tooltip="{
                disabledText: 'Фильтр по всем значениям в справочнике, кроме выбранных',
                activeText: 'Выключить фильтр по всем значениям в справочнике, кроме выбранных',
                notActiveText: 'Включить фильтр по всем значениям в справочнике, кроме выбранных',
              }"
              :useCustomColors="true"
              @checkboxChange="transactionTypes.reverse = $event"
            />
          </div>
          <div v-if="switcherLocal === 'personal_account' && areFiltersExpanded && areFiltersExpandedMobile" class="col col-12 col-md-4 col-xl-2 col--transaction-id">
            <c-input
              v-model="filtersForm.selectedTransactionId"
              type="text"
              label="№ ведомости/проводки"
              placeholder="Любой"
              :clearable="true"
            />
          </div>
          <div  v-if="switcherLocal === 'personal_account' && areFiltersExpanded && areFiltersExpandedMobile" class="col col-12 col-md-4 col-xl-3 col--transaction-filial">
            <c-select-2
              v-model="filtersForm.selectedFilials"
              type="select"
              label="Филиал"
              :multiple="true"
              :searchable="true"
              :placeholder="'Все'"
              :items="referencesByColumns.filial"
              :checkbox-value="filials.reverse"
              :checkbox="true"
              :checkbox-type="'icon'"
              :checkbox-tooltip="{
                disabledText: 'Фильтр по всем значениям в справочнике, кроме выбранных',
                activeText: 'Выключить фильтр по всем значениям в справочнике, кроме выбранных',
                notActiveText: 'Включить фильтр по всем значениям в справочнике, кроме выбранных',
              }"
              :useCustomColors="true"
              @checkboxChange="filials.reverse = $event"
            />
          </div>
          <div v-if="switcherLocal === 'personal_account' && areFiltersExpanded && areFiltersExpandedMobile" class="col col-12 col-md-4 col-xl-3 col--transaction-post">
            <c-select-2
              v-model="filtersForm.selectedPost"
              type="select"
              label="Должность"
              :placeholder="'Все'"
              :items="posts.items"
              :clearable="true"
            />
          </div>
          <div class="col col-12 col-md-12 col-xl-4 offset-xl-2 col--actions">
            <c-button
              v-if="switcherLocal === 'personal_account'"
              icon="chevron"
              class="arrow-button finance-change-filters__switcher finance-change-filters__switcher--desktop"
              :class="{ 'expanded-filters': !areFiltersExpanded }"
              @click="expandHideFilters"
            />
            <c-button
              v-if="switcherLocal === 'personal_account' && areFiltersExpandedMobile"
              class="finance-change-filters__switcher finance-change-filters__switcher--mobile"
              :label="areFiltersExpanded ? 'Свернуть фильтры' : 'Показать фильтры'"
              size="small"
              @click="expandHideFiltersMobile"
            />
            <c-button
              class="action-button"
              v-if="switcherLocal === 'personal_account' && areFiltersExpandedMobile"
              label="Сбросить"
              size="large"
              @click="resetFilters"
            />
            <c-button
              class="action-button"
              v-if="switcherLocal === 'personal_account' && areFiltersExpandedMobile"
              label="Применить"
              color="primary"
              @click="applyFilters"
            />
          </div>
          <div v-if="switcherLocal === 'personal_account'" class="col col-12 col-md-12 col-xl-12 col--table-actions">
            <c-switcher
              v-if="canRestoreTransactions"
              v-model="operationsStatus"
              class="finance__switcher h-switcher finance-account-status"
              type="group"
              :items="[
                { label: 'Активные', value: 'active' },
                { label: 'Удаленные', value: 'removed' },
              ]"
            />

            <c-button-dropdown
              class="olap-actions"
              icon="arrow"
              type="dropdown"
              label="Действия"
              :dropdown="{
                position: 'left',
                items: [
                  { icon: 'filter-drop', iconColor: 'secondary', label: 'Сбросить фильтры столбцов', emit: 'resetColumnFilters', class: `${this.tableDataPersonal.activeFilteredColumns.length ? '' : 'disabled'}` },
                  { icon: 'cog', label: 'Настроить столбцы', emit: 'openColumnSettingsModal' },
                  { icon: 'google', iconColor: 'success', label: 'Выгрузить в Google Таблицы', emit: 'changeGoogleFormSubmit' },
                  { icon: 'print', label: 'Распечатать расчетный лист', emit: 'print' },
                ],
              }"
              @resetColumnFilters="resetColumnFilters"
              @openColumnSettingsModal="openColumnSettingsModal"
              @changeGoogleFormSubmit="changeGoogleFormSubmit"
              @print="print"
            />
          </div>
        </div>
      </div>

      <google-form class="google-form" style="display: none;" :sp="sp" :googleFormIsSubmitted="googleFormIsSubmitted"></google-form>
      
      <m-table-settings
        ref="columnSettings"
        :columns="defaultColumns"
        :disabled-columns="tableDataPersonal.disabledColumns"
        :default-disabled-columns="tableDataPersonal.defaultDisabledColumns"
        @apply="submitTableSettings"
      />

      <div class="finance-change-history-table">
        <c-data-table
          v-if="!isLoadingData && switcherLocal === 'personal_account'"
          ref="accountHistory"
          class="finance-change-history-table-personal-account'"
          :levels="1"
          :sorted-column="tableDataPersonal.sortedColumn"
          :disabled-columns="tableDataPersonal.disabledColumns"
          :filtered-columns="tableDataPersonal.filteredColumns"
          :active-filtered-columns="tableDataPersonal.activeFilteredColumns"
          :data="tableDataPersonal"
          :reference-list="referenceFilterList"
          :empty-records-label="'Записи не найдены'"
          :operations-status="operationsStatus"
          @sortedEvent="onTableSort"
          @getReferenceValues="setColumnReferenceFilterList"
          @reset-column-filters="tableDataPersonal.activeFilteredColumns = []"
          @remove-column-filter="onColumnFilterRemove"
          @set-column-filter="onSetColumnFilter"
          @set-column-filter-by-index="onSetColumnFilterByIndex"
          @disable-column-sorted-flag="onDisableColumnSortedFlag"
          @change-sorting-column="onSortingColumnChange"
          @remove="removeTransaction"
          @restore="restoreTransaction"
          @editRecord="editRecord"
        />

        <!-- <c-data-table
          v-if="!isLoadingData && switcherLocal === 'accountable-transaction'"
          ref="accountHistory"
          class="finance-change-history-table-personal-account'"
          :levels="1"
          :sorted-column="tableDataPersonal.sortedColumn"
          :disabled-columns="tableDataPersonal.disabledColumns"
          :filtered-columns="tableDataPersonal.filteredColumns"
          :active-filtered-columns="tableDataPersonal.activeFilteredColumns"
          :data="tableDataPersonal"
          :reference-list="referenceFilterList"
          :empty-records-label="'Записи не найдены'"
          :operations-status="operationsStatus"
          @sortedEvent="onTableSort"
          @getReferenceValues="setColumnReferenceFilterList"
          @reset-column-filters="tableDataPersonal.activeFilteredColumns = []"
          @remove-column-filter="onColumnFilterRemove"
          @set-column-filter="onSetColumnFilter"
          @set-column-filter-by-index="onSetColumnFilterByIndex"
          @disable-column-sorted-flag="onDisableColumnSortedFlag"
          @change-sorting-column="onSortingColumnChange"
          @remove="removeTransaction"
          @restore="restoreTransaction"
          @editRecord="editRecord"
        /> -->

        <c-data-table
          v-if="!isLoadingData && !isLoadingAccountableData && switcherLocal === 'accountable-transaction'"
          ref="accountHistory"
          class="finance-change-history-table-accountable-transaction"
          :levels="1"
          :sorted-column="tableDataAccountable.sortedColumn"
          :disabled-columns="tableDataAccountable.disabledColumns"
          :filtered-columns="tableDataAccountable.filteredColumns"
          :active-filtered-columns="tableDataAccountable.activeFilteredColumns"
          :data="tableDataAccountable"
          :reference-list="referenceFilterList"
          :empty-records-label="'Изменений пока нет'"
          :operations-status="operationsStatus"
          @sortedEvent="onTableSortAccountable"
          @getReferenceValues="setColumnReferenceFilterList"
          @reset-column-filters="tableDataAccountable.activeFilteredColumns = []"
          @remove-column-filter="onColumnFilterRemoveAccountable"
          @set-column-filter="onSetColumnFilterAccountable"
          @set-column-filter-by-index="onSetColumnFilterByIndexAccountable"
          @disable-column-sorted-flag="onDisableColumnSortedFlagAccountable"
          @change-sorting-column="onSortingColumnChangeAccountable"
          @remove="removeTransaction"
          @restore="restoreTransaction"
          @editRecord="editRecord"
        />


        <c-data-table-personal-employee
          v-if="!isLoadingData && switcherLocal === 'deposit'"
          ref="table"
          :class="{
            'finance-change-history-table-personal-account': switcherLocal === 'personal_account',
            'finance-change-history-table-deposit': switcherLocal === 'deposit',
          }"
          empty-records-label="Записи не найдены"
          :sorted-column="tableDataDeposit.sortedColumn"
          :levels="1"
          :disabled-columns="[]"
          :data="tableDataDeposit"
          @sortedEvent="refreshTable"
        />
      </div>
    </div>

    <transition name="fade">
      <display-shown-items-count
        v-if="switcherLocal === 'personal_account' && !isLoadingData && !isLoadingMoreRecords"
        :total-items-count="totalItemsCount"
        :shown-items-count="tableDataPersonal.records.length"
      />
      <display-shown-items-count
        v-if="switcherLocal === 'accountable-transaction' && !isLoadingData && !isLoadingMoreRecords"
        :total-items-count="totalItemsCountAccountable"
        :shown-items-count="tableDataAccountable.records.length"
      />
    </transition>

    <c-loader
      v-if="isLoadingData || isLoadingMoreRecords || isLoadingAccountableData"
      label="Данные загружаются"
      :active="isLoadingData || isLoadingMoreRecords || isLoadingAccountableData"
      :height="isLoadingMoreRecords ? '200' : '400'"
    />
    <top-button root=".layout"></top-button>
  </div>
</template>

<script>
import { onScrollEnd } from "@/helpers/events";
import { mapGetters, mapState } from "vuex";
import moment from "moment";
import Loader from "@/components/loader";
import Button from "@/components/controls2/Button";
import Button1 from "@/components/controls/button";
import Input from "@/components/controls2/Input";
import Switcher from "@/components/controls2/Switcher";
import TopButton from "@/components/top-button";
import DataTablePersonalEmployee from "@/pages/personal-employee/additions/data-table-personal-employee";
import FinanceTransactionModal from "./components/finance-transaction-modal";
import AccountHistoryTable from "./components/account-history-table";
import MRemoveTransaction from "./components/remove-transaction-modal";
import { AccountOperation } from "@/entities/models/account-operation";
import GoogleForm from "./components/google/index";
import { userPermissionsList } from "@/constants/userPermissions";
import newTransactionModal from "./components/type-modal";
import editTransactionModal from "@/pages/financial-transactions/components/type-modal";
import DataTable from "./components/data-table";
import TableSettingsModal from "@/components/modals/table-columns/modal/";
import DisplayShownItemsCount from "@/components/display-shown-items-count";
import Select2 from "@/components/controls2/Select";
import CButtonDropdown from "@/components/controls/button-dropdown";

export default {
  props: ["filialId", "filialName", "workerFullName"],
  name: "personal-employee-finance",
  components: {
    "c-button": Button,
    "c-button-1": Button1,
    "c-input": Input,
    "c-switcher": Switcher,
    "c-data-table-personal-employee": DataTablePersonalEmployee,
    "m-finance-transaction": FinanceTransactionModal,
    "c-loader": Loader,
    AccountHistoryTable,
    TopButton,
    GoogleForm,
    MRemoveTransaction,
    newTransactionModal,
    editTransactionModal,
    "c-data-table": DataTable,
    "m-table-settings": TableSettingsModal,
    DisplayShownItemsCount,
    "c-select-2": Select2,
    CButtonDropdown
  },
  data() {
    return {
      currencyLabel: '฿',
      sortIsInit: false,
      isFirstInit: true,
      isFirstInitAccountable: true,
      isLoadingData: false,
      isLoadingAccountableData: false,
      switcherLocal: this.$route.query.tab ? this.$route.query.tab : "personal_account",
      switcherLocalDefaultItems: [
        { label: 'Личный счёт', value: 'personal_account' },
        { label: 'Депозит', value: 'deposit' },
        { label: 'Подотчет', value: 'accountable-transaction' },
      ],
      periodLocal: null,
      periodStart: "",
      periodEnd: "",
      periodIsInit: false,
      isShowFinanceTransactionModal: false,
      personalAccountAmountLocal: 0,
      depositAmountLocal: 0,
      depositAmountMaxLocal: 0,
      currentUserPersonalAmountLocal: 0,
      userFilialId: 0,
      operationsStatus: "active",
      isMoreDataAvailable: true,
      isLoadingMoreRecords: false,
      page: 1,
      periodFlag: true,
      tableDataPersonal: {
        summaryAddedAmount: null,
        summaryWithdrawAmount: null,
        columns: [],
        userColumns: [],
        actions: true,
        type: "finance",
        records: [],
        sortedColumn: {
          sortBy: this.$route.query.personalAccountSortBy ? this.$route.query.personalAccountSortBy : "date_user",
          sortType: this.$route.query.personalAccountSortType ? this.$route.query.personalAccountSortType : "desc",
        },
        defaultDisabledColumns: [],
        filteredColumns: [],
        disabledColumns: [],
        settingsModal: false,
        activeFilteredColumns: [],
        globalFilters: [],
        activeFilteredColumnsQueryLocal: null,
        globalFiltersQueryLocal: null,
      },
      referenceFilterList: [],
      referencesByColumns: {
        filial: [],
        company: [],
        post: [],
        type_post: [],
        author: [],
        author_create: [],
        author_update: [],
        transaction_type: [],
        money_source: [],
      },
      columnSequence: ["id", "date_user", "date_created", "date_changed", "filial", "company", "post", "type_post", "author", "author_create", "author_update", "amount_before",
      "added_amount", "withdraw_amount", "amount_after",  "transaction_method", "transaction_type", "money_source", "reason", "comment", "delete_author", "delete_date", "delete_comment"],
      defaultColumns: [],
      tableDataPersonalAccount: {
        records: [],
        sortBy: this.$route.query.personalAccountSortBy ? this.$route.query.personalAccountSortBy : "id",
        desc: this.$route.query.personalAccountSortType !== "asc",
      },
      tableDataDeposit: {
        type: "finance",
        columns: [],
        records: [],
        actions: false,
        enabledFields: [],
        levels: 1,
        filteredColumns: [],
        activeFilteredColumns: [],
        globalFilters: [],
        sortedColumn: {
          sortBy: this.$route.query.depositSortBy ? this.$route.query.depositSortBy : "date_create",
          sortType: this.$route.query.depositSortType ? this.$route.query.depositSortType : "desc",
        },
      },
      sp: {},
      filters: {},
      filtersForm: {
        selectedTransactionTypes: "",
        selectedTransactionId: "",
        selectedFilials: "",
        selectedPost: "",
      },
      transactionTypes: {
        reverse: false,
        items: [],
        selectedItems: [],
        groups: [
          {
            label: "Списание",
            value: "withdraw",
            name: "withdraw",
            color: "#ff238d",
          },
          {
            label: "Начисление",
            value: "deposit",
            name: "deposit",
            color: "#12c971",
          }
        ],
        defaultGroups: [
          {
            label: "Списание",
            value: "withdraw",
            name: "withdraw",
            color: "#ff238d",
          },
          {
            label: "Начисление",
            value: "deposit",
            name: "deposit",
            color: "#12c971",
          }
        ],
      },
      filials: {
        reverse: false,
      },
      posts: {
        items: [],
        reverse: false,
      },
      googleFormIsSubmitted: false,
      areFiltersExpanded: true,
      areFiltersExpandedMobile: true,

      accountableTransactionAmountLocal: 0,
      tableDataAccountable: {
        test: [],
        summaryAddedAmount: null,
        summaryWithdrawAmount: null,
        columns: [],
        userColumns: [],
        actions: false,
        type: "finance",
        subtype: "accountable",
        records: [],
        sortedColumn: {
          sortBy: "date",
          sortType: "desc",
        },
        defaultDisabledColumns: [],
        filteredColumns: [],
        disabledColumns: [],
        settingsModal: false,
        activeFilteredColumns: [],
        globalFilters: [],
        activeFilteredColumnsQueryLocal: null,
        globalFiltersQueryLocal: null,
        columnSequence: ["amount", "date", "author", "balance", "comment"],
        page: 1,
      },
    };
  },
  computed: {
    ...mapGetters("personalEmployee", ["getTableColumnsFinancePersonalAccount", "getTableColumnsFinanceDeposit"]),
    ...mapGetters(["getUserPermissions"]),
    ...mapState({
      userColumns: (state) => state.personalEmployee.userColumns,
      totalItemsCount: (state) => state.personalEmployee.totalItemsCount,
      totalPages: (state) => state.personalEmployee.totalPages,
      totalItemsCountAccountable: (state) => state.personalEmployee.totalItemsCountAccountable,
      totalPagesAccountable: (state) => state.personalEmployee.totalPagesAccountable,
    }),
    displayFinanceChangeButton() {
      return (
        (this.switcherLocal === "personal_account" && this.userHavePermissionTransactionPersonalAccount()) ||
        (this.switcherLocal === "deposit" && this.userHavePermissionTransactionDeposit()) ||
        (this.switcherLocal === "accountable-transaction" && this.userHavePermissionTransactionAccountable())
      );
    },

    switcherLocalItems() {
      return this.switcherLocalDefaultItems.filter(item => {
        if (item.value === "personal_account") {
          return this.userHavePermissionPersonalAccount()
        } else if (item.value === "deposit") {
          return this.userHavePermissionDeposit();
        } else if (item.value === "accountable-transaction") {
          return this.userHavePermissionAccountable();
        }
      })
    },

    noFiltersApplied() {
      return !Object.values(this.tableDataPersonal.activeFilteredColumns).find((filter) => filter.value);
    },

    canRemoveTransactions() {
      return this.getUserPermissions.includes(userPermissionsList.worker.transactions.remove);
    },

    canRestoreTransactions() {
      return this.getUserPermissions.includes(userPermissionsList.worker.transactions.restore);
    },

    order() {
      if (this.switcherLocal === 'personal_account') {
        const { sortBy, sortType } = this.tableDataPersonal.sortedColumn;
        if (sortType !== "desc") return sortBy;
        return `-${sortBy}`;
      }
      if (this.switcherLocal === 'accountable-transaction') {
        const { sortBy, sortType } = this.tableDataAccountable.sortedColumn;
        if (sortType !== "desc") return sortBy;
        return `-${sortBy}`;
      }
    },
  },

  watch: {
    switcherLocal(value) {
      this.$refs.financePeriod.periodReset();
      this.periodStart = "";
      this.periodEnd = "";
      this.periodLocal = null;

      const newQuery = {};
      Object.entries(this.$route.query).forEach(([key, value]) => {
        let filterKey = 'date';

        if (!key.startsWith(`${filterKey}_column`)) {
          newQuery[key] = value;
        }
      });
      this.$router.replace({ name: "personal-employee-finance", query: newQuery }, () => {});

      // this.setQueryParams();

      if (value === "personal_account") {
        this.tableDataPersonal.activeFilteredColumns = this.tableDataPersonal.activeFilteredColumns.filter(filter => filter.id !== "date");
        this.tableDataPersonal.sortedColumn.sortBy = "date_user";
        this.setQueryParams({}, true);
        this.getPersonalAccountData();
        // this.calculatePersonalAccountAmount()
      } else if (value === "deposit") {
        this.tableDataDeposit.sortedColumn.sortBy = "date_create";
        this.setQueryParams({}, true);
        console.log("swither");
        this.getDepositData();
        // this.getPersonalAccountData();
        // this.calculateDepositAmount()
      } else if (value === "accountable-transaction") {
        this.tableDataAccountable.sortedColumn.sortBy = "date";
        this.setQueryParams({}, true);
        this.getAccountableTransactionData();
      }
    },
    operationsStatus() {
      this.getPersonalAccountData();
      this.page = 1;
    },
    $route(to) {
      // console.log("change route", to);
    },
    "tableDataPersonal.activeFilteredColumns": {
      handler() {
        console.log('watch1')
        if (!this.isLoadingData) {
          this.isLoadingData = true;

          // this.tableDataPersonal.activeFilteredColumns.forEach((column, i) => {
          //   this.tableDataPersonal.activeFilteredColumns = this.tableDataPersonal.activeFilteredColumns.filter((otherColumn, j) => (otherColumn.id !== column.id) || (otherColumn.id === column.id && j === i))
          // })

          console.log('watch2', this.tableDataPersonal.activeFilteredColumns)
          this.setTableColumnFilters();
          
          this.page = 1;

          this.getRecordsPersonal().then(() => {
            this.isLoadingData = false;
            console.log('333')
          });
        }
      },
      deep: true,
    },
    "tableDataAccountable.activeFilteredColumns": {
      handler() {
        if (!this.isLoadingData) {
          this.isLoadingData = true;

          this.setTableColumnFiltersAccountable();
          
          this.tableDataAccountable.records = [];
          this.tableDataAccountable.page = 1;

          this.getRecordsAccountable().then(() => {
            this.isLoadingData = false;
            console.log('111')
          });
        }
      },
      deep: true,
    },
    "this.sp": {
      handler() {
        this.$store.commit("personalEmployee/setPersonalParams", this.sp);
      },
      deep: true
    },
    "periodLocal"(value) {
      this.setPeriodValue();

      // console.log('period', value)

      let periodFilterOptions = {
        id: "date",
        searchType: "range",
        type: "date",
        value: `${this.periodStart}-${this.periodEnd}`
      }

      if (this.switcherLocal !== "personal_account") {
        if (this.switcherLocal === "accountable-transaction") {
          // let periodColumnIndex = this.tableDataAccountable.activeFilteredColumns.findIndex(column => column.id === "date");

          // if (this.periodLocal && this.periodLocal.length) {
          //   if (this.tableDataAccountable.activeFilteredColumns[periodColumnIndex]) {
          //     this.tableDataAccountable.activeFilteredColumns[periodColumnIndex] = periodFilterOptions;
          //   } else {
          //     this.onSetColumnFilterAccountable(periodFilterOptions)
          //   }
          // } else {
          //   this.tableDataAccountable.activeFilteredColumns = this.tableDataAccountable.activeFilteredColumns.filter(filter => filter.id !== "date");
          // }
        } else {
          // let periodColumnIndex = this.tableDataPersonal.activeFilteredColumns.findIndex(column => column.id === "date");

          // if (this.periodLocal && this.periodLocal.length) {
          //   if (this.tableDataPersonal.activeFilteredColumns[periodColumnIndex]) {
          //     this.tableDataPersonal.activeFilteredColumns[periodColumnIndex] = periodFilterOptions;
          //   } else {
          //     this.onSetColumnFilter(periodFilterOptions)
          //   }
          // } else {
          //   this.tableDataPersonal.activeFilteredColumns = this.tableDataPersonal.activeFilteredColumns.filter(filter => filter.id !== "date");
          // }
        }
        if (this.switcherLocal === "deposit" || this.switcherLocal === "accountable-transaction") {
          if (!value) {
            const newQuery = {};
            Object.entries(this.$route.query).forEach(([key, value]) => {
              let filterKey = 'global_date';

              if (!key.startsWith(filterKey)) {
                newQuery[key] = value;
              }
            });
            this.$router.replace({ name: "personal-employee-finance", query: newQuery }, () => {});
          } else {
            this.setTableColumnFilters();
            this.setTableColumnFiltersAccountable();
          }
        }
      }

      if (this.switcherLocal === "deposit") {
        console.log("period data");
        this.getDepositData();
      } else if (this.switcherLocal === "accountable-transaction" && this.periodFlag) {

        this.isLoadingAccountableData = true;
        
        this.getRecordsAccountable().then(res => {
          this.isLoadingAccountableData = false;
          this.isLoadingData = false;
          console.log('222')
        })
        this.periodFlag = false;
        setTimeout(() => {
          this.periodFlag = true;
        }, 2000);
      }
    },
    page() {
      this.setQueryParams();
    },
    "tableDataAccountable.page"() {
      this.setQueryParams();
    },
  },

  async created() {
    await this.$store.dispatch("employees/getReferenceValues", "filial").then((res) => {
      this.filialItems = res.data.map((item) => ({ id: item.id, value: item.id, label: item.name }));

      if (this.$route.query.filial) {
        const c = this.filialItems.findIndex(
          (filial) => filial.value.toString() === this.$route.query.filial.toString(),
        );
        if (c !== -1) this.filialLocal = this.filialItems[c];
      }
    });


    if (!this.$route.query.tab) {
      if (!this.userHavePermissionPersonalAccount() && this.userHavePermissionDeposit()) {
        this.switcherLocal = "deposit";
      } else if (!this.userHavePermissionPersonalAccount() && !this.userHavePermissionDeposit() && this.userHavePermissionAccountable()) {
        this.switcherLocal = "accountable-transaction";
      }
    }

    if (this.switcherLocal === "personal_account") {
      const { query } = this.$route;
      if (query.status === "removed" && this.canRestoreTransactions) {
        this.operationsStatus = "removed";
      }

      if (this.userHavePermissionPersonalAccount()) {
        this.getPersonalAccountData();
      } else {
        await this.$router.push({ name: "error-403" });
      }
    } else if (this.switcherLocal === "deposit") {
      if (this.userHavePermissionDeposit()) {
        this.getDepositData();
      } else {
        await this.$router.push({ name: "error-403" });
      }
    } else if (this.switcherLocal === "accountable-transaction") {
      if (this.userHavePermissionAccountable()) {
        this.getAccountableTransactionData();
      } else {
        await this.$router.push({ name: "error-403" });
      }
    }

    this.getCurrencyLabel()

    await this.$store.dispatch("personalEmployee/transactions/fetchNewWorkersList")
    await this.$store.dispatch("personalEmployee/transactions/fetchTransactionTypes")
    await this.$store.dispatch("referenceReasonsForFines/getFinesCollection");
    await this.$store.dispatch("referenceReasonsForBonuses/getBonusesCollection");


  },

  mounted() {
    const layout = document.querySelector(".layout");
    layout.addEventListener("scroll", this.handleLayoutScroll);
  },

  beforeDestroy() {
    const layout = document.querySelector(".layout");
    layout.removeEventListener("scroll", this.handleLayoutScroll);
  },

  methods: {
    getCurrencyLabel() {
      this.notifications.isLoaded = true;
      this.$store.dispatch("personalEmployee/getCurrencyLabel").then((result) => {
        console.log(result);

        this.currencyLabel = result;
        this.notifications.isLoaded = false;
      });
    },

    editRecord(record) {
      this.$refs.editTransactionModal.open(record);
    },
    removeTransactionSubmit() {
      this.applyFilters();
      this.getPersonalAccountData();
    },
    changeGoogleFormSubmit() {
      this.googleFormIsSubmitted = true;

      setTimeout(() => {
        this.googleFormIsSubmitted = false
      }, 1000);
    },
    setTableColumnFilters() {
      const columnFilters = this.getTableColumnFilters();
      const globalFilters = this.getGlobalFilters();
      this.filters = { columnFilters, globalFilters, ...this.getCommonFilters() };
      this.setQueryParams({ ...this.filters });
    },
    setTableColumnFiltersAccountable() {
      const columnFilters = this.getTableColumnFiltersAccountable();
      this.filters = { columnFilters, ...this.getCommonFiltersAccountable() };
      this.setQueryParams({ ...this.filters });
    },

    getTableColumnFilters() {
      return this.tableDataPersonal.activeFilteredColumns.reduce((acc, currentFilter) => {
        let columnFilter = {};
        let columnId = currentFilter.id;
        let filterValue = "";

        if (currentFilter.type === "list" && Array.isArray(currentFilter.value) && currentFilter.value.length) {
          filterValue = currentFilter.value.map((f) => f.value).join(",");
        } else {
          filterValue = currentFilter.value;
        }

        if (currentFilter.type === "date" && currentFilter.searchType === "range") {
          filterValue = currentFilter.value.split(',');
        }

        columnFilter = {
          [columnId]: {
            type: currentFilter.type,
            value: filterValue,
            searchType: currentFilter.searchType,
          },
        };

        return { ...acc, ...columnFilter };
      }, {});
    },

    getGlobalFilters() {
      return this.tableDataPersonal.globalFilters.reduce((acc, currentFilter) => {
        let columnFilter = {};
        let columnId = currentFilter.id;
        let filterValue = "";

        if (currentFilter.type === "list" && Array.isArray(currentFilter.value) && currentFilter.value.length) {
          filterValue = currentFilter.value.map((f) => f.value).join(",");
        } else {
          filterValue = currentFilter.value;
        }

        if (currentFilter.type === "date" && currentFilter.searchType === "range") {
          filterValue = currentFilter.value.split(',');
        }

        columnFilter = {
          [columnId]: {
            type: currentFilter.type,
            value: filterValue,
            searchType: currentFilter.searchType,
          },
        };

        return { ...acc, ...columnFilter };
      }, {});
    },

    getTableColumnFiltersAccountable() {
      return this.tableDataAccountable.activeFilteredColumns.reduce((acc, currentFilter) => {
        let columnFilter = {};
        let columnId = currentFilter.id;
        let filterValue = "";

        if (currentFilter.type === "list" && Array.isArray(currentFilter.value) && currentFilter.value.length) {
          filterValue = currentFilter.value.map((f) => f.value).join(",");
        } else {
          filterValue = currentFilter.value;
        }

        if (currentFilter.type === "date" && currentFilter.searchType === "range") {
          filterValue = currentFilter.value.split(',');
        }

        columnFilter = {
          [columnId]: {
            type: currentFilter.type,
            value: filterValue,
            searchType: currentFilter.searchType,
          },
        };

        return { ...acc, ...columnFilter };
      }, {});
    },

    getCommonFilters() {
      return {
        sortingData: this.tableDataPersonal.sortedColumn,
        page: this.page,
      };
    },

    getCommonFiltersAccountable() {
      return {
        sortingData: this.tableDataAccountable.sortedColumn,
        page: this.tableDataAccountable.page,
        global_date: this.$refs.financePeriod.period.start.input ? this.$refs.financePeriod.period.start.input + "-" + this.$refs.financePeriod.period.end.input : ""
      };
    },

    // setQueryParams(filters = {}) {
    //   // const { query } = this.$route;
    //   // let allQueries = { ...query, ...this.tableDataPersonal.sortedColumn };

    //   // if (filters.columnFilters) {
    //   //   const columnFilters = {};
    //   //   Object.entries(filters.columnFilters).forEach(([key, { value, searchType, type }]) => {
    //   //     columnFilters[`${key}_column`] = value;
    //   //     columnFilters[`${key}_column_searchType`] = searchType;
    //   //     columnFilters[`${key}_column_filterType`] = type;
    //   //   });

    //   //   allQueries = { ...allQueries, ...columnFilters };
    //   // }

    //   // if (JSON.stringify(query) !== JSON.stringify(allQueries)) {
    //   //   this.$router.replace({ name: "personal-employee-finance", query: allQueries });
    //   // }
    // },

    setQueryParamsAccountable(filters = {}) {
      // const { query } = this.$route;
      // let allQueries = { ...query, ...this.tableDataAccountable.sortedColumn };

      // if (filters.columnFilters) {
      //   const columnFilters = {};
      //   Object.entries(filters.columnFilters).forEach(([key, { value, searchType, type }]) => {
      //     columnFilters[`${key}_column`] = value;
      //     columnFilters[`${key}_column_searchType`] = searchType;
      //     columnFilters[`${key}_column_filterType`] = type;
      //   });

      //   allQueries = { ...allQueries, ...columnFilters };
      // }

      // if (JSON.stringify(query) !== JSON.stringify(allQueries)) {
      //   this.$router.replace({ name: "personal-employee-finance", query: allQueries });
      // }
    },

    handleLayoutScroll() {
      onScrollEnd(async () => {
        if (!this.isMoreDataAvailable || this.isLoadingData || this.isLoadingMoreRecords) {
          return;
        }

        if (this.page < this.totalPages && this.switcherLocal === 'personal_account') {
          this.page = Number(this.page) + 1;
          this.isLoadingMoreRecords = true;

          await this.getRecordsPersonal();

          setTimeout(() => {
            this.isLoadingMoreRecords = false;
          }, 500);
        }

        if (this.tableDataAccountable.page < this.totalPagesAccountable && this.switcherLocal === 'accountable-transaction') {
          this.tableDataAccountable.page += 1;
          this.isLoadingMoreRecords = true;

          await this.getRecordsAccountable();

          setTimeout(() => {
            this.isLoadingMoreRecords = false;
          }, 500);
        }
      });
    },

    setColumnReferenceFilterList(e) {
      this.referenceFilterList = this.referencesByColumns[e.id];
    },

    onColumnFilterRemove(columnIndex) {
      let deletedFilter;
      if (this.switcherLocal === "personal_account") [deletedFilter] = this.tableDataPersonal.activeFilteredColumns.splice(columnIndex, 1);
      if (this.switcherLocal === "accountable-transaction") [deletedFilter] = this.tableDataAccountable.activeFilteredColumns.splice(columnIndex, 1);
      const newQuery = {};
      if (deletedFilter && deletedFilter.id) {
        Object.entries(this.$route.query).forEach(([key, value]) => {
          let filterKey = deletedFilter.id;
          if (filterKey === "postCategorySpecialty") {
            filterKey = "posts";
          }
          if (!key.startsWith(`${filterKey}_column`)) {
            newQuery[key] = value;
          }
        });
        this.$router.replace({ name: "personal-employee-finance", query: newQuery }, () => {});
      }
    },

    onGlobalFilterRemove(columnIndex) {
      let deletedFilter;
      if (this.switcherLocal === "personal_account") [deletedFilter] = this.tableDataPersonal.globalFilters.splice(columnIndex, 1);
      const newQuery = {};
      if (deletedFilter && deletedFilter.id) {
        Object.entries(this.$route.query).forEach(([key, value]) => {
          let filterKey = deletedFilter.id;
          if (filterKey === "postCategorySpecialty") {
            filterKey = "posts";
          }
          if (!key.startsWith(`${filterKey}_column`)) {
            newQuery[key] = value;
          }
        });
        this.$router.replace({ name: "personal-employee-finance", query: newQuery }, () => {});
      }
    },

    onColumnFilterRemoveAccountable(columnIndex) {
      let [deletedFilter] = this.tableDataAccountable.activeFilteredColumns.splice(columnIndex, 1);

      this.tableDataAccountable.activeFilteredColumns = this.tableDataAccountable.activeFilteredColumns.filter(column => column.id !== deletedFilter.id);

      const newQuery = {};
      Object.entries(this.$route.query).forEach(([key, value]) => {
        let filterKey = deletedFilter.id;
        if (filterKey === "postCategorySpecialty") {
          filterKey = "posts";
        }
        if (!key.startsWith(`${filterKey}_column`)) {
          newQuery[key] = value;
        }
      });
      const { query } = this.$route;
      if (JSON.stringify(query) !== JSON.stringify(newQuery)) {
        this.$router.replace({ name: "personal-employee-finance", query: newQuery }, () => {});
      }
    },

    onSetColumnFilter(filterOptions) {
      this.tableDataPersonal.activeFilteredColumns.push(filterOptions);
    },

    onSetColumnFilterAccountable(filterOptions) {
      this.tableDataAccountable.activeFilteredColumns.push(filterOptions);
    },

    onSetColumnFilterByIndex(columnIndex, filterOptions) {
      this.tableDataPersonal.activeFilteredColumns[columnIndex] = filterOptions;
    },
    
    onSetColumnFilterByIndexAccountable(columnIndex, filterOptions) {
      this.tableDataAccountable.activeFilteredColumns[columnIndex] = filterOptions;
    },

    onDisableColumnSortedFlag(e) {
      console.log("onDisableColumnSortedFlag", e)
    },

    onDisableColumnSortedFlagAccountable(e) {
      console.log("onDisableColumnSortedFlagAccountable", e)
      this.tableDataAccountable.columns[e].isSorted = false;
    },

    onSortingColumnChange(e) {
      console.log("onSortingColumnChange", e)
    },

    onSortingColumnChangeAccountable(e) {
      console.log("onSortingColumnChangeAccountable", e)
      this.tableDataAccountable.records = [];
      this.tableDataAccountable.page = 1;
    },

    resetColumnFilters() {
      const columnIds = this.tableDataPersonal.activeFilteredColumns.filter((column) => column.id);
      columnIds.forEach((column) => {
        this.onColumnFilterRemove(column);
      });
      this.tableDataPersonal.activeFilteredColumns = [];
    },

    // onColumnFilterRemove(columnIndex) {
    //   const [deletedFilter] = this.tableDataPersonal.activeFilteredColumns.splice(columnIndex, 1);
    //   const newQuery = {};
    //   Object.entries(this.$route.query).forEach(([key, value]) => {
    //     let filterKey = deletedFilter.id;
    //     if (filterKey === "postCategorySpecialty") {
    //       filterKey = "posts";
    //     }
    //     if (!key.startsWith(`${filterKey}_column`)) {
    //       newQuery[key] = value;
    //     }
    //   });
    //   // this.$router.replace({ name: "personal-employee-finance", query: newQuery });
    // },

    openColumnSettingsModal() {
      this.$refs.columnSettings.open(this.userColumns);
    },

    async submitTableSettings(selectedColumns) {
      this.tableDataPersonal.columns.filter((c) => selectedColumns.includes(c.id));

      this.isLoadingData = true;
      await this.$store.dispatch("personalEmployee/saveUserColumns", selectedColumns);

      this.filterTableColumns();
      this.isLoadingData = false;
    },

    modalIsSubmitted() {
      this.getPersonalAccountData();
    },
    print() {
      const workerId = this.$route.params.id;

      let query = {
        workerId,
        periodStart: this.periodStart,
        periodEnd: this.periodEnd,
        print: 1,
        sort: "date_user",
        deleted: this.operationsStatus === "active" ? 0 : 1
      }

      if (this.periodStart) {
        query.date_user_search_type = "range",
        query.date_user_value = this.periodStart;
        query.date_user_value_end = this.periodEnd;
      }

      if (this.sp.filters && this.sp.filters.globalFilters) {
        console.log(this.sp.filters.globalFilters);
        for (let filterName in this.sp.filters.globalFilters) {
          query[`${filterName}_search_type`] = this.sp.filters.globalFilters[filterName].searchType

          if (this.sp.filters.globalFilters[filterName].type === "date" && this.sp.filters.globalFilters[filterName].searchType === "range") {
            query[`${filterName}_value`] = this.sp.filters.globalFilters[filterName].value[0]
            query[`${filterName}_value_end`] = this.sp.filters.globalFilters[filterName].value[1]
          } else if (this.sp.filters.globalFilters[filterName].type === "number" && this.sp.filters.globalFilters[filterName].searchType === "4") {
            query[`${filterName}_value`] = this.sp.filters.globalFilters[filterName].value.start
            query[`${filterName}_value_end`] = this.sp.filters.globalFilters[filterName].value.end
          } else {
            query[`${filterName}_value`] = this.sp.filters.globalFilters[filterName].value
          }
        }
      }

      if (this.sp.filters && this.sp.filters.columnFilters) {

        for (let filterName in this.sp.filters.columnFilters) {
          query[`${filterName}_search_type`] = this.sp.filters.columnFilters[filterName].searchType

          if (this.sp.filters.columnFilters[filterName].type === "date" && this.sp.filters.columnFilters[filterName].searchType === "range") {
            query[`${filterName}_value`] = this.sp.filters.columnFilters[filterName].value[0]
            query[`${filterName}_value_end`] = this.sp.filters.columnFilters[filterName].value[1]
          } else if (this.sp.filters.columnFilters[filterName].type === "number" && this.sp.filters.columnFilters[filterName].searchType === "4") {
            query[`${filterName}_value`] = this.sp.filters.columnFilters[filterName].value.start
            query[`${filterName}_value_end`] = this.sp.filters.columnFilters[filterName].value.end
          } else {
            query[`${filterName}_value`] = this.sp.filters.columnFilters[filterName].value
          }
        }
      }

      const routeData = this.$router.resolve({
        name: "personal-account-print",
        query: query,
      });

      window.open(routeData.href, "_blank");
    },

    userHavePermissionPersonalAccount() {
      return (
        // this.getUserPermissions.includes("viewOwnPersonalAmount") ||
        this.getUserPermissions.includes("viewPersonalAmount") ||
        this.getUserPermissions.includes("updatePersonalAmount")
      );
    },

    userHavePermissionDeposit() {
      return (
        // this.getUserPermissions.includes("viewOwnDeposit") ||
        this.getUserPermissions.includes("viewWorkerDeposit") ||
        this.getUserPermissions.includes("updateWorkerDeposit")
      );
    },

    userHavePermissionAccountable() {
      return (
        this.getUserPermissions.includes("viewAccountableHistory") ||
        this.getUserPermissions.includes("updateAccountableHistory")
      );
    },

    userHavePermissionTransactionPersonalAccount() {
      return this.getUserPermissions.includes("updatePersonalAmount");
    },

    userHavePermissionTransactionDeposit() {
      return this.getUserPermissions.includes("updateWorkerDeposit");
    },

    userHavePermissionTransactionAccountable() {
      return this.getUserPermissions.includes("updateAccountableHistory");
    },

    onTableSort(column) {
      this.page = 1;
      this.tableDataPersonal.sortedColumn.sortBy = column.sortBy;
      this.tableDataPersonal.sortedColumn.sortType = column.sortType;
      
      this.getPersonalAccountData();
    },

    onTableSortAccountable(column) {
      this.tableDataAccountable.page = 1;
      this.tableDataAccountable.sortedColumn.sortBy = column.sortBy;
      this.tableDataAccountable.sortedColumn.sortType = column.sortType;
      
      this.setTableColumnFiltersAccountable();
      this.getRecordsAccountable();
    },

    removeOperation(operation) {
      if (confirm("Проводка будет удалена. Вы уверены?")) {
        this.$store
          .dispatch("personalEmployee/deleteTransactionPersonalAccount", {
            id: operation.id
          })
          .then(res => {
            this.getPersonalAccountData();
          });        
      }
    },    

    filterTableColumns() {
      this.tableDataPersonal.columns = []
      this.tableDataPersonal.columns = this.defaultColumns.filter((c) => this.userColumns.includes(c.id));
    },

    async getColumnsPersonal() {
      let forDelete = 0;
      if (this.operationsStatus === "removed") forDelete = 1

      await this.$store.dispatch("personalEmployee/fetchUserColumns");

      await this.$store.dispatch("personalEmployee/getColumnsTransactionsPersonalAccount", forDelete).then((res) => {
        const columns = res.columns;
        this.tableDataPersonal.columns = [];
        this.defaultColumns = [];
        this.tableDataPersonal.filteredColumns = [];

        this.columnSequence.forEach(columnId => {
          columns.forEach(column => {
            if (columnId === column.code) {
              this.tableDataPersonal.columns.push({
                id: column.code,
                label: column.name,
                fullName: column.name,
                type: column.data_type,
                level: column.level,
                isCategory: column.is_category,
                disabled: column.disabled,
                isSorted: false,
              })
            }
          })
        })

        this.defaultColumns = this.tableDataPersonal.columns;

        this.filterTableColumns();

        this.tableDataPersonal.filteredColumns = this.tableDataPersonal.columns.map(column => (column.id))
      })
    },

    async getReferencesPersonal() {
      await this.$store.dispatch("personalEmployee/getUserInfo", this.$route.params.id).then((res) => {
        const data = res.response;

        if (data) {
          const posts = data.postCodes;

          this.posts.items = posts.map(post => ({
            value: post.post_code,
            label: post.name,
          }))
        }
      })

      await this.$store.dispatch("personalEmployee/transactions/fetchFilialsList").then((res) => {
        this.referencesByColumns.filial = [];

        this.referencesByColumns.filial = res
          .sort((a, b) => b.sort - a.sort)
          .map((filial) => ({
            value: filial.id,
            label: filial.name,
          }))
      })
      
      await this.$store.dispatch("personalEmployee/transactions/fetchCompanies").then((res) => {
        this.referencesByColumns.company = [];

        Object.entries(res).forEach(([key, value]) => {
          this.referencesByColumns.company.push({
            value: key,
            label: value
          })
        });
      })

      await this.$store.dispatch("personalEmployee/getPostList").then((res) => {
        const posts = res.response

        this.referencesByColumns.post = posts.map(post => ({
          value: post.id,
          label: post.name
        }))
      })

      await this.$store.dispatch("personalEmployee/getTypePostList").then((res) => {
        const typePosts = res.items

        this.referencesByColumns.type_post = typePosts.map(typePost => ({
          value: typePost.id,
          label: typePost.name
        }))
      })
      
      await this.$store.dispatch("personalEmployee/getTransactionTypeList").then((res) => {
        const transactionTypes = res;  

        res = res.sort((a, b) => Number(b.sort) - Number(a.sort))
        
        // this.referencesByColumns.transaction_type = transactionTypes.map(transactionType => ({
        //   value: transactionType.id,
        //   label: transactionType.name
        // }))

        this.transactionTypes.items = transactionTypes.map((item) => ({
          label: item.short_name + ' ' + item.name,
          formatLabel: `<span class="short-name" style='color: ${item.type === 'withdraw' ? '#ff238d' : '#12c971'}'>${item.short_name}</span> ${item.name}`,
          resultLabel: item.short_name,
          subLabel: item.description,
          value: item.id,
          group: item.type,
          backgroundColor: item.type === 'withdraw' ? '#FFE6F2' : '#D0F4E3',
        }));

        this.referencesByColumns.transaction_type = this.transactionTypes.items
      })
      
      await this.$store.dispatch("personalEmployee/getMoneySourceList").then((res) => {
        const moneySources = res  
        
        this.referencesByColumns.money_source = moneySources.map(moneySource => ({
          value: moneySource.id,
          label: moneySource.name
        }))
      })

      await this.$store.dispatch("personalEmployee/transactions/fetchNewWorkersList");
    },

    async getRecordsPersonal() {
      const userId = this.$route.params.id;

      const { sortBy, sortType } = this.tableDataPersonal.sortedColumn;

      this.sp = {
        userId,
        sort: this.order,
        periodStart: this.periodStart,
        periodEnd: this.periodEnd,
        deleted: this.operationsStatus === "removed" ? 1 : 0,
        page: this.page,
        filters: this.filters
      };

      if (this.isFirstInit) {
        console.log("12341423");
        for (let i = 1; i <= this.page; i++) {
          this.sp.page = i;
          await this.$store.dispatch("personalEmployee/getListTransactionsPersonalAccount", this.sp).then((res) => {
            if (res) {
              if (res && res.length > 0) {
                if (this.page === 1) {
                  this.tableDataPersonal.records = res.map((record) => new AccountOperation(record));
                } else {
                  this.tableDataPersonal.records = [...this.tableDataPersonal.records, ...res.map((record) => new AccountOperation(record))];
                }
                this.isMoreDataAvailable = true;
              } else {
                this.tableDataPersonal.records = [];
                this.isMoreDataAvailable = false;
              }
            } 

            const queryFilters = {
              ...(this.periodStart === "" ? null : { periodStart: this.periodStart }),
              ...(this.periodEnd === "" ? null : { periodEnd: this.periodEnd }),
            };
            setTimeout(() => {
              this.setPeriodInput();
            }, 300);
          });
        }

        this.isFirstInit = false
      } else {
        if (this.switcherLocal!="personal_account") return;
        console.log("777");
        await this.$store.dispatch("personalEmployee/getListTransactionsPersonalAccount", this.sp).then((res) => {
          if (res) {
            if (res && res.length > 0) {
              if (this.page === 1) {
                this.tableDataPersonal.records = res.map((record) => new AccountOperation(record));
              } else {
                this.tableDataPersonal.records = [...this.tableDataPersonal.records, ...res.map((record) => new AccountOperation(record))];
              }
              this.isMoreDataAvailable = true;
            } else {
              this.tableDataPersonal.records = [];
              this.isMoreDataAvailable = false;
            }
          } 

          const queryFilters = {
            ...(this.periodStart === "" ? null : { periodStart: this.periodStart }),
            ...(this.periodEnd === "" ? null : { periodEnd: this.periodEnd }),
          };

          // this.$router
          //   .replace({
          //     name: "personal-employee-finance",
          //     query: {
          //       personalAccountSortBy: sortBy,
          //       personalAccountSortType: sortType,
          //       tab: this.switcherLocal,
          //       status: this.operationsStatus,
          //       ...queryFilters,
          //     },
          //   })
          //   .catch(() => {});

          setTimeout(() => {
            this.setPeriodInput();
          }, 300);
        });
      }

      // Get summary
      await this.getSummaryPersonal();
    },

    async getAmountPersonal() {
      const workerId = this.$route.params.id;

      await this.$store.dispatch("personalEmployee/getWorkerAmount", workerId).then((res) => {
        this.personalAccountAmountLocal = res.personal_amount;
      })
    },

    async getSummaryPersonal() {
      const userId = this.$route.params.id;

      this.sp = {
        userId,
        sort: this.order,
        periodStart: this.periodStart,
        periodEnd: this.periodEnd,
        deleted: this.operationsStatus === "removed" ? 1 : 0,
        is_delete: this.operationsStatus === "removed" ? 1 : 0,
        page: this.page,
        filters: this.filters
      };

      await this.$store.dispatch("personalEmployee/getWorkerSummary", this.sp).then((res) => {
        if (this.tableDataPersonal.records.length) {
          this.tableDataPersonal.summaryAddedAmount = res.added_amount;
          this.tableDataPersonal.summaryWithdrawAmount = res.withdraw_amount;
        } else {
          this.tableDataPersonal.summaryAddedAmount = null;
          this.tableDataPersonal.summaryWithdrawAmount = null;
        }
      })
    },

    async getPersonalAccountData() {
      this.isLoadingData = true;

      // Get amount
      await this.getAmountPersonal();

      // Get columns
      await this.getColumnsPersonal();

      // Get references     
      await this.getReferencesPersonal();

      await this.updateFilters();
      await this.setFiltersFromQuery();
      await this.setQueryParams();

      // await this.applyFilters();

      // Get records
      // await this.getRecordsPersonal();

      // setTimeout(() => {
      //   this.isLoadingData = false;
      // }, 500);
    },

    getCommonFilters() {
      return {
        sortingData: this.tableDataPersonal.sortedColumn,
        page: this.page,
      };
    },

    updateFilters() {
      if (this.switcherLocal === "personal_account") this.filters = { ...this.getCommonFilters(), columnFilters: this.getTableColumnFilters() };
      if (this.switcherLocal === "accountable-transaction") this.filters = { ...this.getCommonFiltersAccountable(), columnFilters: this.getTableColumnFiltersAccountable() };
    },

    async setFiltersFromQuery() {
      const { query } = this.$route;

      if ("sortBy" in query) {
        if (!this.sortIsInit) {
          this.tableDataPersonal.sortedColumn.sortBy = query.sortBy;
          this.tableDataAccountable.sortedColumn.sortBy = query.sortBy;
          this.tableDataDeposit.sortedColumn.sortBy = query.sortBy;
          this.sortIsInit = true
        }
      }
      if ("sortType" in query) {
        if (!this.sortIsInit) {
          this.tableDataPersonal.sortedColumn.sortType = query.sortType;
          this.tableDataAccountable.sortedColumn.sortType = query.sortType;
          this.tableDataDeposit.sortedColumn.sortType = query.sortType;
          this.sortIsInit = true
        }
      }

      if ("page" in query) {
        if (this.switcherLocal === "personal_account" || this.switcherLocal === "deposit") this.page = Number(query.page);
        if (this.switcherLocal === "accountable-transaction") this.tableDataAccountable.page = Number(query.page);
      }

      const queryFilters = {};

      Object.entries(query).forEach(([key, value]) => {
        let filterKey = "";
        if (key.endsWith("_column")) {
          filterKey = key.replace("_column", "");
          queryFilters[filterKey] = { value };
          queryFilters[filterKey] = { ...queryFilters[filterKey], type: query[`${key}_filterType`] };
          queryFilters[filterKey] = { ...queryFilters[filterKey], searchType: query[`${key}_searchType`] };
        }
      });
      
      this.isLoadingData = false;

      if (this.switcherLocal === "personal_account") {
        if (!Object.keys(queryFilters).length) {
          this.isLoadingData = true;
          await this.getRecordsPersonal().then(() => {
            this.isLoadingData = false;
          });
        }
      } else {
        setTimeout(() => {
          this.setPeriodInput();
        }, 300);
      }

      if (this.switcherLocal === "accountable-transaction") {
        if (!queryFilters.length && !query.global_date) {
          await this.getRecordsAccountable().then(() => {
            this.isLoadingData = false;
            this.isLoadingAccountableData = false;
          });
        }
      }
      console.log(queryFilters)
      Object.entries(queryFilters).forEach(async ([key, value]) => {
        let filterId = key;
        if (filterId === "posts") {
          filterId = "postCategorySpecialty";
        }
        const filter = {
          id: filterId,
          type: value.type,
          searchType: value.searchType,
        };
        
        if (filter.type === "list") {
          const selectedValues = value.value.split(",");
          filter.value = selectedValues;
          
          if (key.startsWith("global_")) {
            if (this.referencesByColumns[filterId.replace("global_", "")]) {
              filter.value = this.referencesByColumns[filterId.replace("global_", "")].filter((f) =>
                selectedValues.includes(f.value.toString()),
              );
            }
          } else {
            if (this.referencesByColumns[filterId]) {
              filter.value = this.referencesByColumns[filterId].filter((f) =>
                selectedValues.includes(f.value.toString()),
              );
            }
          }
        } else {
          filter.value = value.value;
        }

        if (filter.id === "global_filial") {
          this.filtersForm.selectedFilials = filter.value;
          this.filials.reverse = filter.searchType === "1" ? false : true
        }
        if (filter.id === "global_post") {
          // console.log(filter.value)
          this.filtersForm.selectedPost = filter.value[0];
          this.filtersForm.selectedPostReverse = filter.searchType === "1" ? false : true
        }
        if (filter.id === "global_date") {
          this.filtersForm.selectedDateCreated = filter.value;
          this.$refs.financePeriod.period.setPeriodFlag = true;
          this.$refs.financePeriod.period.range = "custom";
          
          let array = filter.value.split('-');
          if (array.length === 1) {
            this.$refs.financePeriod.setDateInputTypeDate(filter.value);
            this.$refs.financePeriod.period.start.input = filter.value;
            this.$refs.financePeriod.period.end.input = filter.value;
          } else {
            this.$refs.financePeriod.setDateInputTypeDate(`${array[0]} - ${array[1]}`);
            this.$refs.financePeriod.period.start.input = String(array[0]);
            this.$refs.financePeriod.period.end.input = String(array[1]);
          }
        }

        if (filter.id === "global_transaction_type") {
          this.filtersForm.selectedTransactionTypes = this.transactionTypes.items.filter(type => filter.value.find(item => Number(item.value) === Number(type.value)))
          this.transactionTypes.reverse = filter.searchType === "1" ? false : true
        }
        
        if (filter.id === "global_money_source") {
          this.filtersForm.selectedMoneySource = filter.value;
          this.filtersForm.selectedMoneySourceReverse = filter.searchType === "1" ? false : true
        }

        if (filter.id === "global_id") {
          this.filtersForm.selectedTransactionId = filter.value;
        }

        if (filter.id === "global_worker") {
          this.filtersForm.selectedWorker = this.referencesByColumns.author.find(item => String(item.label) === String(filter.value))
        }
        if (filter.id === "global_author") {
          this.filtersForm.selectedAuthor = this.referencesByColumns.author.find(item => String(item.label) === String(filter.value))
        }
        if (filter.id === "global_transaction_method_filter") {
          this.filtersForm.selectedTransactionMethod = this.referencesByColumns.transaction_method.filter(item => filter.value.find(value => Number(value) === Number(item.value)))
        }

        if (this.switcherLocal === "personal_account") {
          if (key.startsWith("global_")) {
            this.tableDataPersonal.globalFilters.push(filter);
            console.log(this.tableDataPersonal.globalFilters)
          } else {
            this.tableDataPersonal.activeFilteredColumns.push(filter);
            console.log(this.tableDataPersonal.activeFilteredColumns)
          }
        }
        
        if (this.switcherLocal === "accountable-transaction") this.tableDataAccountable.activeFilteredColumns.push(filter);
      });

      setInterval(() => {
        if (query.global_date && !this.periodIsInit) {
          this.periodLocal = query.global_date;
          // this.$refs.financePeriod.period.setPeriodFlag = true;
          // this.$refs.financePeriod.period.range = "custom";
          // console.log('filter.value', filter.value)
          let array = query.global_date.split('-');
          if (array.length === 1) {
            this.$refs.financePeriod.setDateInputTypeDate(query.global_date);
            this.$refs.financePeriod.period.start.input = query.global_date;
            this.$refs.financePeriod.period.end.input = query.global_date;
            // this.periodStart = filter.value;
            // this.periodEnd = filter.value;
          } else {
            this.$refs.financePeriod.setDateInputTypeDate(`${array[0]} - ${array[1]}`);
            this.$refs.financePeriod.period.start.input = String(array[0]);
            this.$refs.financePeriod.period.end.input = String(array[1]);
            // this.periodStart = String(array[0]);
            // this.periodEnd = String(array[1]);
          }
          // this.applyFilters()
          this.periodIsInit = true
        }
      }, 1000);

      if (this.tableDataPersonal.globalFilters.length) {
        this.applyFilters();
      }
    },

    setQueryParams(filters = {}, clear=false) {
      const { query } = clear ? {} : this.$route;
      let allQueries = {};
      if (this.switcherLocal === "personal_account") {
        allQueries = { ...query, ...this.tableDataPersonal.sortedColumn, tab: this.switcherLocal, status: this.operationsStatus, page: this.page };
      }
      if (this.switcherLocal === "deposit") {
        allQueries = { ...query, ...this.tableDataDeposit.sortedColumn, tab: this.switcherLocal, page: this.page };
      }
      if (this.switcherLocal === "accountable-transaction") {
        allQueries = { ...query, ...this.tableDataAccountable.sortedColumn, tab: this.switcherLocal, page: this.tableDataAccountable.page };
      }

      if (filters.columnFilters) {
        const columnFilters = {};
        Object.entries(filters.columnFilters).forEach(([key, { value, searchType, type }]) => {
          if (type == "date" && searchType === "range") {
            columnFilters[`${key}_column`] = value.join(',');
          } else {
            columnFilters[`${key}_column`] = value;
          }
          
          columnFilters[`${key}_column_searchType`] = searchType;
          columnFilters[`${key}_column_filterType`] = type;
        });

        allQueries = { ...allQueries, ...columnFilters };
      }

      if (filters.globalFilters) {
        const globalFilters = {};
        Object.entries(filters.globalFilters).forEach(([key, { value, searchType, type }]) => {
          if (type == "date" && searchType === "range") {
            globalFilters[`${key}_column`] = value.join(',');
          } else {
            globalFilters[`${key}_column`] = value;
          }
          
          globalFilters[`${key}_column_searchType`] = searchType;
          globalFilters[`${key}_column_filterType`] = type;
        });

        allQueries = { ...allQueries, ...globalFilters };
      }

      if (filters.global_date) {
        allQueries = { ...allQueries, global_date: filters.global_date }
      }
      console.log(this.$route.name, 'allQueries', allQueries, this.tableDataPersonal.sortedColumn, this.tableDataDeposit.sortedColumn, this.tableDataAccountable.sortedColumn)
      if (this.$route.name=="personal-employee-finance" && JSON.stringify(query) !== JSON.stringify(allQueries)) {
        this.$router.replace({ name: "personal-employee-finance", query: allQueries }, () => {});
      }
    },

    async getDepositData() {
      this.isLoadingData = true;

     // this.updateFilters();
     // this.setFiltersFromQuery();
     // this.setQueryParams();

      const userId = this.$route.params.id;

      this.tableDataDeposit.columns = this.getTableColumnsFinanceDeposit.map((column) => {
        column.isSorted = column.id === this.tableDataDeposit.sortedColumn.sortBy;
        return column;
      });

      await this.$store
        .dispatch("personalEmployee/getListTransactionsDeposit", {
          userId,
          sortBy: this.tableDataDeposit.sortedColumn.sortBy,
          sortType: this.tableDataDeposit.sortedColumn.sortType,
          periodStart: this.periodStart,
          periodEnd: this.periodEnd,
        })
        .then((res) => {
          this.tableDataDeposit.records = [];

          if (res.response.personal_amount) {
            this.currentUserPersonalAmountLocal = res.response.personal_amount;
          }

          if (res.response.deposit_info) {
            this.depositAmountMaxLocal = res.response.deposit_info.norm;
            this.depositAmountLocal = res.response.deposit_info.summ;
          }

         // console.log('!!!!', res.response.operations);
          if (res.response.operations && res.response.operations.length > 0) {
            this.tableDataDeposit.actions = res.response.operations.some((rec) => rec.comment !== null);
            this.tableDataDeposit.records = res.response.operations.map((record) => ({
              amount: {
                value: record.action === "-" ? -record.amount : record.amount,
              },
              date_create: {
                value: record.date,
              },
              operation_author: {
                value: record.author,
              },
              balance: {
                value: record.balance === 0 ? "0" : record.balance,
              },
              comment: {
                value: record.comment,
              },
              depositAmountMax: this.depositAmountMaxLocal,
              isShowRow: true,
            }));
          }

          const queryFilters = {
            ...(this.periodStart === "" ? null : { periodStart: this.periodStart }),
            ...(this.periodEnd === "" ? null : { periodEnd: this.periodEnd }),
          };

          // this.$router
          //   .replace({
          //     name: "personal-employee-finance",
          //     query: {
          //       depositSortBy: this.tableDataDeposit.sortedColumn.sortBy,
          //       depositSortType: this.tableDataDeposit.sortedColumn.sortType,
          //       tab: this.switcherLocal,
          //       ...queryFilters,
          //     },
          //   })
          //   .catch(() => {});

          setTimeout(() => {
            this.isLoadingData = false;
          }, 500);

          // setTimeout(() => {
          //   this.setPeriodInput();
          // }, 300);
        });
    },

    resetTableDataPersonal() {
      // this.tableDataPersonal.columns = this.defaultColumns;
      // this.tableDataPersonal.userColumns = [];
      // this.tableDataPersonal.records = [];
      // this.tableDataPersonal.defaultDisabledColumns = [];
      // this.tableDataPersonal.filteredColumns = [];
      // this.tableDataPersonal.disabledColumns = [];
      // this.tableDataPersonal.activeFilteredColumns = [];
      // this.tableDataPersonal.globalFilters = [];
    },

    refreshTable() {
      if (this.switcherLocal === "personal_account") {
        this.getPersonalAccountData();
      } else {
        console.log("refreh table");
        this.getDepositData();
        // this.getPersonalAccountData();
      }
    },

    getDepositAmountStatus() {
      const amount = this.depositAmountLocal;
      let status = "";
      switch (true) {
        case amount === 0:
          status = "Не внесён";
          break;
        case amount === this.depositAmountMaxLocal:
          status = "Внесён";
          break;
        case amount > this.depositAmountMaxLocal:
          status = "Внесён излишне";
          break;
        case amount > 0 && amount < this.depositAmountMaxLocal:
          status = "Внесён частично";
          break;
        default:
          status = "";
      }
      return status;
    },

    formatAmount(x) {
      if (x > 0) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      }
      if (x < 0) {
        return `− ${(-1 * x).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}`;
      }
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },

    setPeriodInput() {
      if (this.periodStart.length > 0 && this.periodEnd.length > 0) {
        this.$refs.financePeriod.period.start.input = this.periodStart;
        this.$refs.financePeriod.period.end.input = this.periodEnd;

        const period = `${this.periodStart}-${this.periodEnd}`;
        const today = moment().startOf("day").format("DD.MM.YYYY").toString();
        const yesterday = moment().startOf("day").subtract(1, "day").format("DD.MM.YYYY").toString();
        const firstDayCurrentWeek = moment().startOf("day").startOf("week").format("DD.MM.YYYY").toString();
        const lastDayCurrentWeek = moment().startOf("day").format("DD.MM.YYYY").toString();
        const firstDayLastWeek = moment()
          .startOf("day")
          .startOf("week")
          .subtract(1, "week")
          .format("DD.MM.YYYY")
          .toString();
        const lastDayLastWeek = moment()
          .startOf("day")
          .endOf("week")
          .subtract(1, "week")
          .format("DD.MM.YYYY")
          .toString();
        const sevenDayAgo = moment().startOf("day").subtract(6, "day").format("DD.MM.YYYY").toString();
        const firstDayCurrentMonth = moment().startOf("day").startOf("month").format("DD.MM.YYYY").toString();
        const firstDayLastMonth = moment()
          .startOf("day")
          .subtract(1, "month")
          .startOf("month")
          .format("DD.MM.YYYY")
          .toString();
        const lastDayLastMonth = moment()
          .startOf("day")
          .subtract(1, "month")
          .endOf("month")
          .format("DD.MM.YYYY")
          .toString();

        if (today === this.periodStart && today === this.periodEnd) {
          this.$refs.financePeriod.dateValue = "Сегодня";
        } else if (yesterday === this.periodStart && yesterday === this.periodEnd) {
          this.$refs.financePeriod.dateValue = "Вчера";
        } else if (firstDayCurrentWeek === this.periodStart && lastDayCurrentWeek === this.periodEnd) {
          this.$refs.financePeriod.dateValue = "С начала недели";
        } else if (firstDayLastWeek === this.periodStart && lastDayLastWeek === this.periodEnd) {
          this.$refs.financePeriod.dateValue = "Прошлая неделя";
        } else if (today === this.periodEnd && sevenDayAgo === this.periodStart) {
          this.$refs.financePeriod.dateValue = "Последние 7 дней";
        } else if (firstDayCurrentMonth === this.periodStart && today === this.periodEnd) {
          this.$refs.financePeriod.dateValue = "Текущий месяц";
        } else if (firstDayLastMonth === this.periodStart && lastDayLastMonth === this.periodEnd) {
          this.$refs.financePeriod.dateValue = "Прошлый месяц";
        } else if (
          this.periodStart === moment().startOf("day").subtract(1, "month").format("DD.MM.YYYY").toString() &&
          today === this.periodEnd
        ) {
          this.$refs.financePeriod.dateValue = "Последний месяц";
        } else {
          this.$refs.financePeriod.dateValue = period;
        }
      }
    },

    addDataToPersonalAccount(type, value) {
      const data = value;
      this.$store
        .dispatch("personalEmployee/executeTransactionPersonalAccount", {
          operationType: type === "make" ? "add" : "cut",
          reasonId: data.reasonLocal.value,
          filialId: data.filialLocal ? data.filialLocal.value : null, 
          newReasonText: data.newReasonTextLocal,
          workerId: this.$route.params.id,
          workerIdWhoContributed: data.whoContributedLocal.value || null,
          amount: data.summLocal,
          date: data.dateEntryLocal,
          comment: data.commentLocal,
          authorIsUser: data.whoContributedLocal.isUser ? 1 : 0,
        })
        .then(() => {
          this.getPersonalAccountData();
        });
    },

    addDataToDeposit(type, value) {
      const data = value;

      this.$store
        .dispatch("personalEmployee/executeTransactionDeposit", {
          operationType: type === "make" ? "add" : "cut",
          workerId: this.$route.params.id,
          workerIdWhoContributed: data.whoContributedLocal.value,
          amount: data.summLocal,
          date: data.dateEntryLocal,
          comment: data.commentLocal,
          usePersonalAccount: data.switcherLocal ? "1" : "0",
          authorIsUser: data.whoContributedLocal.isUser ? 1 : 0,
          filial_id: data.selectedFilial ? data.selectedFilial.value : null,
          post_code: data.selectedPost ? data.selectedPost.value : null,
          company_id: data.selectedCompany ? data.selectedCompany.value : null
        })
        .then((res) => {
          if (res.response.status === "success") {
            this.$notify({
              group: "success-message",
              data: {
                textMessage: type === "make" ? "Средства на депозит внесены" : "Средства с депозита сняты",
              },
            });
          }
          this.getDepositData();
          // this.getPersonalAccountData();
        })
        .catch((e) => {
          this.$notify({
            group: "error-message",
            data: {
              textMessage: "Произошла ошибка. Попробуйте ещё раз."
            },
          });
        })
    },

    addDataToAccountableTransaction(type, value) {
      const data = value;

      this.$store
        .dispatch("personalEmployee/executeTransactionAccountableTransaction", {
          operationType: type === "make" ? "add" : "cut",
          workerId: this.$route.params.id,
          workerIdWhoContributed: data.whoContributedLocal ? data.whoContributedLocal.value : null,
          amount: data.summLocal,
          date: data.dateEntryLocal,
          comment: data.commentLocal,
          usePersonalAccount: data.switcherLocal ? "1" : "0",
          filial_id: data.selectedFilial ? data.selectedFilial.value : null,
          post_code: data.selectedPost ? data.selectedPost.value : null,
          company_id: data.selectedCompany ? data.selectedCompany.value : null,
          money_source_id: data.selectedMoneySource ? data.selectedMoneySource.value : null
        })
        .then((res) => {
          if (res.response.status === "success") {
            this.$notify({
              group: "success-message",
              data: {
                textMessage: type === "make" ? "Средства на подотчёт внесены" : "Средства с подотчёта сняты",
              },
            });
          }

          this.tableDataAccountable.records = [];
          this.tableDataAccountable.page = 1;

          this.getDepositData();
          this.getPersonalAccountData();
          this.getAccountableTransactionData();
        })
        .catch((e) => {
          this.$notify({
            group: "error-message",
            data: {
              textMessage: "Произошла ошибка. Попробуйте ещё раз."
            },
          });
        })
    },

    async getColumnsAccountable() {
      await this.$store.dispatch("personalEmployee/getColumnsTransactionsAccountable").then((res) => {
        const columns = res.columns;
        this.tableDataAccountable.columns = [];

        this.tableDataAccountable.columnSequence.forEach(columnId => {
          columns.forEach(column => {
            if (columnId === column.code) {
              this.tableDataAccountable.columns.push({
                id: column.code,
                label: column.name,
                fullName: column.name,
                type: column.data_type,
                level: column.level,
                isCategory: column.is_category,
                disabled: column.disabled,
                isSorted: false,
              })
            }
          })
        })

        this.tableDataAccountable.filteredColumns = this.tableDataAccountable.columns.map(column => (column.id))
      })
    },

    async getRecordsAccountable() {
      let workerId = this.$route.params.id;

      if (this.isFirstInitAccountable) {
        for (let i = 1; i <= this.tableDataAccountable.page; i++) {
          await this.$store
            .dispatch("personalEmployee/getListTransactionsAccountable", {
              workerId,
              sortBy: this.tableDataAccountable.sortedColumn.sortBy,
              sortType: this.tableDataAccountable.sortedColumn.sortType,
              periodStart: this.periodStart,
              periodEnd: this.periodEnd,
              page: i,
              filters: this.tableDataAccountable.activeFilteredColumns,
              sort: this.order,
            })
            .then((res) => {
              this.accountableTransactionAmountLocal = res.accountable_amount;

              // this.tableDataAccountable.records = [];
              let currentRecords = [];
              
              // if (res.response.personal_amount) {
              //   this.currentUserPersonalAmountLocal = res.response.personal_amount;
              // }

              // if (res.response.deposit_info) {
              //   this.depositAmountMaxLocal = res.response.deposit_info.norm;
              //   this.depositAmountLocal = res.response.deposit_info.summ;
              // }

              if (res.operations && res.operations.length) {
                currentRecords = res.operations.map((record) => ({
                  amount: {
                    value: record.amount,
                    style: record.amount > 0 ? "color: #12C971;" : "color: #FF238D;"
                  },
                  date: {
                    value: record.date,
                  },
                  author: record.author,
                  balance: {
                    value: record.balance === 0 ? "0" : record.balance,
                    style: record.balance > 0 ? "padding: 10px 10px 10px 25px; background: #D0F4E3;" : "padding: 10px 10px 10px 25px; background: #FFE6F2;"
                  },
                  comment: {
                    value: record.comment,
                  },
                  isShowRow: true,
                  use_personal_account: record.use_personal_account,
                }));

                this.tableDataAccountable.records = [...this.tableDataAccountable.records, ...currentRecords]
              }

              // const queryFilters = {
              //   ...(this.periodStart === "" ? null : { periodStart: this.periodStart }),
              //   ...(this.periodEnd === "" ? null : { periodEnd: this.periodEnd }),
              // };

              // this.$router
              //   .replace({
              //     name: "personal-employee-finance",
              //     query: {
              //       depositSortBy: this.tableDataDeposit.sortedColumn.sortBy,
              //       depositSortType: this.tableDataDeposit.sortedColumn.sortType,
              //       tab: this.switcherLocal,
              //       ...queryFilters,
              //     },
              //   })
              //   .catch(() => {});

              setTimeout(() => {
                this.setPeriodInput();
              }, 300);
            });
        }

        this.isFirstInitAccountable = false
      } else {
        await this.$store
          .dispatch("personalEmployee/getListTransactionsAccountable", {
            workerId,
            sortBy: this.tableDataAccountable.sortedColumn.sortBy,
            sortType: this.tableDataAccountable.sortedColumn.sortType,
            periodStart: this.periodStart,
            periodEnd: this.periodEnd,
            page: this.tableDataAccountable.page,
            filters: this.tableDataAccountable.activeFilteredColumns,
            sort: this.order,
          })
          .then((res) => {
            this.accountableTransactionAmountLocal = res.accountable_amount;

            // this.tableDataAccountable.records = [];
            let currentRecords = [];
            
            // if (res.response.personal_amount) {
            //   this.currentUserPersonalAmountLocal = res.response.personal_amount;
            // }

            // if (res.response.deposit_info) {
            //   this.depositAmountMaxLocal = res.response.deposit_info.norm;
            //   this.depositAmountLocal = res.response.deposit_info.summ;
            // }

            if (res.operations && res.operations.length) {
              currentRecords = res.operations.map((record) => ({
                amount: {
                  value: record.amount,
                  style: record.amount > 0 ? "color: #12C971;" : "color: #FF238D;"
                },
                date: {
                  value: record.date,
                },
                author: record.author,
                balance: {
                  value: record.balance === 0 ? "0" : record.balance,
                  style: record.balance > 0 ? "padding: 10px 10px 10px 25px; background: #D0F4E3;" : "padding: 10px 10px 10px 25px; background: #FFE6F2;"
                },
                comment: {
                  value: record.comment,
                },
                isShowRow: true,
                use_personal_account: record.use_personal_account,
              }));

              if (this.tableDataAccountable.page === 1) {
                this.tableDataAccountable.records = [ ...currentRecords]
              } else {
                this.tableDataAccountable.records = [...this.tableDataAccountable.records, ...currentRecords]
              }
            }

            // const queryFilters = {
            //   ...(this.periodStart === "" ? null : { periodStart: this.periodStart }),
            //   ...(this.periodEnd === "" ? null : { periodEnd: this.periodEnd }),
            // };

            // this.$router
            //   .replace({
            //     name: "personal-employee-finance",
            //     query: {
            //       depositSortBy: this.tableDataDeposit.sortedColumn.sortBy,
            //       depositSortType: this.tableDataDeposit.sortedColumn.sortType,
            //       tab: this.switcherLocal,
            //       ...queryFilters,
            //     },
            //   })
            //   .catch(() => {});

            setTimeout(() => {
              this.setPeriodInput();
            }, 300);
          });
      }
    },

    async getAccountableTransactionData() {
      console.log("666");
      this.isLoadingData = true;
      this.isLoadingAccountableData = true;


      await this.getColumnsAccountable();

      await this.updateFilters();
      await this.setQueryParams();
      await this.setFiltersFromQuery();


      // await this.getRecordsAccountable();
      // this.isLoadingData = false;
      // this.isLoadingAccountableData = false;
    },

    setPeriodValue() {
      const periodStart = this.$refs.financePeriod.period.start.input;
      const periodEnd = this.$refs.financePeriod.period.end.input;

      if (periodStart !== this.periodStart) this.periodStart = periodStart;
      if (periodEnd !== this.periodEnd) this.periodEnd = periodEnd;
    },

    applyFilters() {
      // this.setPeriodValue();

      // Date period
      let periodFilterOptions = {
        id: "global_date",
        searchType: "range",
        type: "date",
        value: `${this.$refs.financePeriod.period.start.input}-${this.$refs.financePeriod.period.end.input}`
      }

      let periodColumnIndex = this.tableDataPersonal.globalFilters.findIndex(column => column.id === "global_date");

      if (this.$refs.financePeriod.period.start.input) {
        if (this.tableDataPersonal.globalFilters[periodColumnIndex]) {
          this.$set(this.tableDataPersonal.globalFilters[periodColumnIndex], 'value', periodFilterOptions.value)
        } else {
          this.tableDataPersonal.globalFilters.push(periodFilterOptions);
        }
      } else {
        const columnIds = this.tableDataPersonal.globalFilters.filter((column) => ["global_date"].find(columnId => columnId === column.id)).filter((column) => column.id);

        columnIds.forEach((column) => {
          this.onGlobalFilterRemove(column);
        });

        // if (periodColumnIndex > -1) {
        //   this.onColumnFilterRemove("date");
        //   this.tableDataPersonal.activeFilteredColumns = this.tableDataPersonal.activeFilteredColumns.filter(filter => filter.id !== "date");
        // }
      }

      // Transaction types
      let transactionTypesColumnIndex = this.tableDataPersonal.globalFilters.findIndex(column => column.id === "global_transaction_type");

      let transactionTypesFilterOptions = {
        id: "global_transaction_type",
        searchType: this.transactionTypes.reverse ? "2" : "1",
        type: "list",
        value: this.filtersForm.selectedTransactionTypes ? [...this.filtersForm.selectedTransactionTypes] : ""
      }

      if (this.filtersForm.selectedTransactionTypes) {
        if (this.tableDataPersonal.globalFilters[transactionTypesColumnIndex]) {
          this.$set(this.tableDataPersonal.globalFilters[transactionTypesColumnIndex], 'value', transactionTypesFilterOptions.value)
          this.$set(this.tableDataPersonal.globalFilters[transactionTypesColumnIndex], 'searchType', transactionTypesFilterOptions.searchType)
        } else {
          this.tableDataPersonal.globalFilters.push(transactionTypesFilterOptions);
        }
      } else {
        // if (transactionTypesColumnIndex > -1) {
        //   // this.onColumnFilterRemove("transaction_type");
        //   this.tableDataPersonal.globalFilters = this.tableDataPersonal.globalFilters.filter(filter => filter.id !== "global_transaction_type");
        // }
        const columnIds = this.tableDataPersonal.globalFilters.filter((column) => ["global_transaction_type"].find(columnId => columnId === column.id)).filter((column) => column.id);

        columnIds.forEach((column) => {
          this.onGlobalFilterRemove(column);
        });
      }

      // Transaction id
      let transactionIdColumnIndex = this.tableDataPersonal.globalFilters.findIndex(column => column.id === "global_id");

      let transactionIdFilterOptions = {
        id: "global_id",
        searchType: "2",
        type: "string",
        value: this.filtersForm.selectedTransactionId
      }

      if (this.filtersForm.selectedTransactionId) {
        if (this.tableDataPersonal.globalFilters[transactionIdColumnIndex]) {
          this.$set(this.tableDataPersonal.globalFilters[transactionIdColumnIndex], 'value', transactionIdFilterOptions.value)
        } else {
          this.tableDataPersonal.globalFilters.push(transactionIdFilterOptions);
        }
      } else {
        // if (transactionIdColumnIndex > -1) {
        //   // this.onColumnFilterRemove("id");
        //   this.tableDataPersonal.globalFilters = this.tableDataPersonal.globalFilters.filter(filter => filter.id !== "global_id");
        // }
        const columnIds = this.tableDataPersonal.globalFilters.filter((column) => ["global_id"].find(columnId => columnId === column.id)).filter((column) => column.id);

        columnIds.forEach((column) => {
          this.onGlobalFilterRemove(column);
        });
      }

      // Filial
      let filialColumnIndex = this.tableDataPersonal.globalFilters.findIndex(column => column.id === "global_filial");

      let filialFilterOptions = {
        id: "global_filial",
        searchType: this.filials.reverse ? "2" : "1",
        type: "list",
        value: this.filtersForm.selectedFilials ? [...this.filtersForm.selectedFilials] : ""
      }
      
      if (this.filtersForm.selectedFilials && this.filtersForm.selectedFilials.length) {
        if (this.tableDataPersonal.globalFilters[filialColumnIndex]) {
          this.$set(this.tableDataPersonal.globalFilters[filialColumnIndex], 'value', filialFilterOptions.value)
          this.$set(this.tableDataPersonal.globalFilters[filialColumnIndex], 'searchType', filialFilterOptions.searchType)
        } else {
          this.tableDataPersonal.globalFilters.push(filialFilterOptions);
          // this.onSetColumnFilter(filialFilterOptions)
        }
      } else {
        // if (filialColumnIndex > -1) {
        //   // this.onColumnFilterRemove("filial");
        //   this.tableDataPersonal.globalFilters = this.tableDataPersonal.globalFilters.filter(filter => filter.id !== "global_filial");
        // }

        const columnIds = this.tableDataPersonal.globalFilters.filter((column) => ["global_filial"].find(columnId => columnId === column.id)).filter((column) => column.id);

        columnIds.forEach((column) => {
          this.onGlobalFilterRemove(column);
        });
      }

      // Post
      let postColumnIndex = this.tableDataPersonal.globalFilters.findIndex(column => column.id === "global_post");

      let postFilterOptions = {
        id: "global_post",
        searchType: "1",
        type: "list",
        value: this.filtersForm.selectedPost ? this.filtersForm.selectedPost.value : ""
      }
      
      if (this.filtersForm.selectedPost) {
        if (this.tableDataPersonal.globalFilters[postColumnIndex]) {
          this.$set(this.tableDataPersonal.globalFilters[postColumnIndex], 'value', postFilterOptions.value)
        } else {
          this.tableDataPersonal.globalFilters.push(postFilterOptions);
          // this.onSetColumnFilter(postFilterOptions)
        }
      } else {
        // if (postColumnIndex > -1) {
        //   // this.onColumnFilterRemove("post");
        //   this.tableDataPersonal.globalFilters = this.tableDataPersonal.globalFilters.filter(filter => filter.id !== "global_post");
        // }

        const columnIds = this.tableDataPersonal.globalFilters.filter((column) => ["global_post"].find(columnId => columnId === column.id)).filter((column) => column.id);

        columnIds.forEach((column) => {
          this.onGlobalFilterRemove(column);
        });
      }

      this.isLoadingData = true;
      this.setTableColumnFilters();
      this.getRecordsPersonal().then(res => {
        this.isLoadingData = false;
        console.log('222')
      })

      // if (this.switcherLocal === "deposit") {
      //   this.getDepositData();
      //   // this.getPersonalAccountData();
      // }
    },

    resetFilters() {
      // Date period
      // this.$refs.financePeriod.period.setPeriodFlag = true;
      // this.$refs.financePeriod.period.range = "custom";
      // this.$refs.financePeriod.period.start.input = "";
      // this.$refs.financePeriod.period.end.input = "";
      // this.$refs.financePeriod.period.end.selected = null;
      // this.$refs.financePeriod.period.start.selected = null;
      // this.$refs.financePeriod.period.start.highlighted = null;
      // this.$refs.financePeriod.period.end.highlighted = null;
      // this.$refs.financePeriod.dateValue = "";
      this.$refs.financePeriod.periodReset();
      this.periodStart = "";
      this.periodEnd = "";
      this.periodLocal = null;

      // Transaction types
      this.filtersForm.selectedTransactionTypes = "";
      this.transactionTypes.reverse = false;

      // Transaction id
      this.filtersForm.selectedTransactionId = "";

      // Filial
      this.filtersForm.selectedFilials = "";
      this.filials.reverse = false;

      // Post 
      this.filtersForm.selectedPost = "";

      // Active filtered columns
      // this.tableDataPersonal.activeFilteredColumns = this.tableDataPersonal.activeFilteredColumns.filter(filter => filter.id !== "post" && filter.id !== "filial" && filter.id !== "id" && filter.id !== "transaction_type");

      // .forEach(column => this.onColumnFilterRemove(column))
      const columnIds = this.tableDataPersonal.globalFilters.filter((column) => ["global_post", "global_filial", "global_id", "global_transaction_type", "global_date"].find(columnId => columnId === column.id)).filter((column) => column.id);
      columnIds.forEach((column) => {
        this.onGlobalFilterRemove(column);
      });
      // this.resetColumnFilters();

      this.isLoadingData = true;
      this.setTableColumnFilters();
      this.getRecordsPersonal().then(res => {
        this.isLoadingData = false;
      })
    },

    expandHideFilters() {
      this.areFiltersExpanded = !this.areFiltersExpanded;
    },

    expandHideFiltersMobile() {
      this.areFiltersExpandedMobile = !this.areFiltersExpandedMobile;
    },

    removeTransaction(transaction) {
      this.$refs.removeTransaction.open(transaction);
    },

    restoreTransaction(transaction) {
      console.log(transaction);
      this.$store.dispatch("personalEmployee/restoreTransaction", transaction.id.value).then((response) => {
        if (response.success) {
          this.applyFilters();
          this.$notify({
            group: "success-message",
            data: {
              textMessage: 'Проводка на дату <b>' + (transaction.date ? transaction.date.value : transaction.date_user.value) + '</b> успешно восстановлена',
            },
          });
          this.getPersonalAccountData();
        }
      });
    },

    showTransactionModal() {
      if (this.switcherLocal === 'deposit') {
        this.isShowFinanceTransactionModal = true;
        this.$refs.depositModal.open();
      } else if (this.switcherLocal === 'personal_account') {
        this.$refs.typeModal.open();
      } else {
        this.isShowFinanceTransactionModal = true;
        this.$refs.depositModal.open();
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.finance {
  margin-top: 43px;

  @include mobileAndTablet {
    padding-bottom: 60px;
  }

  @include onlyMobile {
    padding-bottom: 40px;
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  &__switcher {
    @media screen and (max-width: 700px) {
      ::v-deep & .c-switcher-group {
        width: 100%;
      }

      ::v-deep & .c-switcher-group .c-switcher-group-item {
        width: 50%;
      }
    }
  }

  &-change {
    margin-top: 20px;
    display: flex;
    align-items: center;

    @media screen and (max-width: 700px) {
      flex-direction: column;
    }

    &-personal-account-amount {
      font-family: Fira Sans;
      font-weight: bold;
      font-size: 45px;
      line-height: 54px;

      & svg {
        font-size: 34px;
        vertical-align: -2px;
      }

      &-green {
        color: #12c971;
      }

      &-red {
        color: #ff238d;
      }

      &-black {
        color: #000000;
      }

      &-gray {
        color: #8E9CBB;
      }
    }

    &-deposit {
      display: flex;
      align-items: center;

      @media screen and (max-width: 700px) {
        flex-direction: column;
        justify-content: center;
      }

      &-amount {
        font-weight: bold;
        font-size: 45px;
        line-height: 54px;

        & svg {
          font-size: 34px;
          vertical-align: -2px;
        }

        &-yellow {
          color: #ffb800;
        }

        &-green {
          color: #12c971;
        }

        &-red {
          color: #ff238d;
        }
      }

      &-description {
        display: flex;
        flex-direction: column;
        margin-left: 19px;

        @media screen and (max-width: 700px) {
          justify-content: center;
          margin-left: 0;
          text-align: center;
          margin-bottom: 3px;
        }

        &-count {
          font-size: 13px;
          line-height: 16px;
        }

        &-desc {
          font-size: 13px;
          line-height: 16px;
        }
      }
    }

    &-button {
      margin-left: 30px;

      @media screen and (max-width: 700px) {
        margin-left: 0;
        margin-top: 12px;
        width: 100%;
      }
    }
  }

  &-change-history {
    margin-top: 23px;

    &-title {
      font-weight: 500;
      font-size: 18px;
      line-height: 22px;
      color: #000000;

      @media screen and (max-width: 700px) {
        font-size: 15px;
        line-height: 18px;
      }
    }

    &-filters {
      margin-top: 21px;
      display: flex;
      align-items: flex-end;

      @media screen and (max-width: 700px) {
        flex-direction: column;
      }

      &-filial {
        max-width: 148px;
        width: 100%;

        @media screen and (max-width: 700px) {
          max-width: 100%;
        }
      }
        
      &-period {
        //max-width: 200px;
        margin-left: 31px;

        ::v-deep & .c-input-container_period {
          transform: none;
          left: 0;
          @media screen and (max-width: 805px) {
            left: -30px;
          }
          @media screen and (max-width: 767px) {
            left: 0;
          }
        }

        @media screen and (max-width: 700px) {
          max-width: 100%;
          width: 100%;
        }
      }

      &-button {
        margin-left: 33px;
        max-width: 130px;

        @media screen and (max-width: 700px) {
          margin-left: 0;
          margin-top: 24px;
          width: 100%;
          max-width: 100%;
        }
      }
    }

    &-table {
      // margin-top: 24px;

      @media screen and (max-width: 700px) {
        margin-top: 7px;
      }

      &-personal-account {
        //max-width: 863px;

        ::v-deep & .c-table__wrapper .c-table__container {
          min-width: 863px;
        }

        //@media screen and (max-width: 768px) {
        //  ::v-deep & .c-table__wrapper .c-table__container {
        //    min-width: 700px;
        //  }
        //}

        @media screen and (max-width: 700px) {
          ::v-deep & .c-table__cell {
            min-width: 250px;
          }
        }
      }

      &-deposit {
        ::v-deep & .c-table__wrapper .c-table__container {
          min-width: 530px;
        }

        @media screen and (max-width: 768px) {
          ::v-deep & .c-table__wrapper .c-table__container {
            min-width: 690px;
          }
        }

        @media screen and (max-width: 700px) {
          ::v-deep & .finance-deposit-cell {
            justify-content: flex-start;
          }
        }
      }

      ::v-deep & .c-table .c-table__wrapper .c-table__container {
        //table-layout: fixed;
      }
    }
  }

  &-change-button {
    padding: 0 25px !important;
  }

  &-loader {
    margin-top: 30px;
    max-width: 865px;

    @media screen and (max-width: 700px) {
      ::v-deep & .loader-overlay {
        width: calc(100% + 40px);
        left: -20px;
        border-right: none;
        border-left: none;
        z-index: 199;
      }
    }
  }

  &-account-actions {
    width: 100%;
    margin-top: 26px;
    margin-bottom: 20px;
  }

  &-account-status {
    margin-right: 10px;
    margin-bottom: 16px;
  }
  &-account-print {
    display: none;
  }

  .google-form {
    /deep/ {
      .c-button {
        width: auto;
      }
      .c-button__wrapper {
        width: auto;
        padding-left: 15px !important;
        padding-right: 15px !important;
      }
      .c-button__label {
        display: inline-block;
      }
    }
  }

  @include bootstrapMd {
    &-account-actions {
      width: auto;
      display: flex;
      margin-left: auto;
      margin-top: 0;
      margin-bottom: 0;
    }
    &-account-status {
      margin-right: 10px;
      margin-bottom: 0;
    }
    .google-form {
      /deep/ {
        .c-button__wrapper {
          width: 30px;
          padding-left: 0px !important;
          padding-right: 0px !important;
        }
        .c-button__icon {
          margin-left: 5px;
        }
        .c-button__label {
          display: none;
        }
      }
    }
  }

  @media (min-width: 1024px) {
    &-account-print {
      display: flex;
      /deep/ {
        .c-button__wrapper {
          width: 30px;
          padding-left: 0px !important;
          padding-right: 0px !important;
        }
        .c-button__icon {
          margin-left: 5px;
        }
        .c-button__label {
          display: none;
        }
      }
    }
  }

  @media (min-width: 1500px) {
    .google-form,
    &-account-print {
      /deep/ {
        .c-button {
          width: auto;
        }
        .c-button__wrapper {
          width: auto;
          padding-left: 15px !important;
          padding-right: 15px !important;
        }
        .c-button__label {
          display: inline-block;
        }
      }
    }
  }

  @media screen and (min-width: 700.02px) and (max-width: 1180px) {
    &-account-print,
    &-account-google {
      width: 30px;
      height: 30px;
      & /deep/ {
        .c-button__wrapper {
          width: 100%;
          height: 100%;
          padding: 0 !important;
          display: flex;
          align-items: center;
          justify-content: center;

          & .c-button__icon {
            margin-left: 0 !important;
          }
        }

        .c-button__label {
          display: none;
        }

        .c-button__icon {
          margin-left: -10px !important;
          display: inline-block;
        }
      }
    }
  }

  .finance-transaction-modal-deposit .c-switcher {width: 300px}
}

.finance-change-history-table-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 15px;
}
.finance-change-history-table-action {
  &:not(:last-child) {
    margin-right: 15px;
  }
}

/deep/ {
  .c-table__shadow {
    right: 82px;
  }
}

.finance-change-filters {
  .col {
    margin-top: 15px;
    margin-bottom: 15px;

    &--actions {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      button {
        &:not(:last-child) {
          margin-right: 10px;

        }
      }

      @include vp-767 {
        flex-wrap: wrap;
      }
    }

    &--table-actions {
      display: flex;
      align-items: center;
      justify-content: space-between;

      @include vp-767 {
        flex-direction: column;
        align-items: flex-end;
        
        .finance-account-status {
          margin-right: 0;
        }
      }
    }
  }
}
.finance-change-history-title {
  margin-bottom: 25px;
}
.finance-change-filters-row {
  align-items: flex-end;
}

/deep/ {
  .c-button__dropdown__container {
    max-width: unset;
  }
  .c-button__dropdown__container__list__item__label {
    white-space: nowrap;
  }
}
.expanded-filters {
  transform: rotate(180deg);
}

.finance-change-filters {
  /deep/ .c-button_circled .c-button-icon {
    top: calc(50% - 6px);
    left: calc(50% - 6px);

    & svg {
      width: 11px;
      height: 11px;
      & path {
        fill: $color-label;
      }
    }
  }
}

.finance-change-filters {
  &--hide {
    .col {
      &--actions {
        margin-left: 0;
      }
    }
    .finance-change-filters__switcher--mobile {
      margin-bottom: 0!important;
    }
  }
  &--deposit {
    .col {
      &--actions {
        margin-left: 0;
        width: fit-content;
        flex: unset;
      }
    }
  }
}
.finance-change-filters__switcher {
  &--mobile {
    display: none;
  }

  @include vp-767 {
    &--desktop {
      display: none;
    }
    &--mobile {
      display: flex;
      width: 100%;
      margin-right: auto!important;
      margin-left: auto;
      max-width: 92vw;

      &:first-child {
        margin-bottom: 20px;
      }

      &:not(:first-child) {
        margin-top: 20px;
        order: 1;
      }
    }
  }
}
/deep/ {
  .c-table .c-table__cell_post span {
    white-space: unset;
  }

  .m-column-filters {
    padding-top: 0;
  }

  @include vp-767 {
    .modal-frame .modal-track .scroll-container {
      padding-right: 20px;
    }
    .finance-transaction-modal-personal-account-buttons {
      display: none;
    }
  }
}

.finance-change {
  @include vp-767 {
    margin-left: auto;
    margin-right: auto;
  }
}

.action-button {
  @include vp-767 {
    width: calc((100% - 10px) / 2);
  }
}

.olap-actions {
  @include vp-767 {
    /deep/ {
      .modal-frame .modal-track .scroll-container {
        padding-right: 20px;
      }
      .c-button__label__left {
        display: none;
      }
      .c-button__wrapper {
        padding: 0;
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
      }
      .c-icon_arrow {
        margin: 0!important;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: fit-content;
        height: fit-content;

        .c-icon__wrapper {
          width: fit-content;
          height: fit-content;
        }

        svg {
          position: static!important;
        }
      }
    }
  }
}

.finance-change-history-table-accountable-transaction {
  min-width: 100%;
}

@media screen and (max-width: 700px) {
  ::v-deep .loader-overlay {
    z-index: 199;
  }
}

.finance-change-history-table-deposit {
  /deep/ {
    .c-table__shadow__finance {
      display: none;
    }
  }
}

.finance {
  /deep/ {
    .loader-overlay {
      z-index: 200;
    }
  }
}

.finance-change-history-filters-period {
  margin-left: 0px;
}
</style>
